export default "<p>{{ 'signingout' | translate }}...</p>\n"